import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import "./index.css";
import App from "./App";
import store from "./components/redux/store";

ReactDOM.createRoot(document.getElementById("root")).render(
  
  <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <BrowserRouter>
  <Provider store={store}>
    <App />
  </Provider>
  </BrowserRouter>
</GoogleOAuthProvider>

);
